<template>
  <f7-page class="main-inventory-regularization-and-count">
    <template #fixed>
      <TheNavbar
        :style="appTheme"
        :nav-title="filtro.location ? `${filtro.location.Codigo} - ${filtro.location.Nombre}` : $t('warehouse.info.countAndInventory')"
        back-btn-enable
        add-btn-enable
        @add-btn="EventPressNewArticle"
      >
        <template #btn-right>
          <img
            src="@/static/icons/ic_qr.svg"
            class="padding-left-half"
            @click="EventOpenCodeSearch"
          >
        </template>
      </TheNavbar>
    </template>
    <div class="search-bar">
      <div>
        {{ `${$t('warehouse.labels.countDateIs')} ${FormatDateTime(filtro.date)}` }}
      </div>
      <div>
        <img
          v-if="mostrarBarraBusqueda === false"
          src="@/static/icons/ic_search-3.svg"
          alt="iconSearch"
          width="24"
          height="24"
          @click="mostrarBarraBusqueda = true"
        >
        <img
          v-if="mostrarBarraBusqueda === true"
          src="@/static/icons/ic_cancel.svg"
          width="12"
          height="12"
          @click="mostrarBarraBusqueda = false"
        >
      </div>
    </div>
    <div
      class="content-accordion"
    >
      <UCAcordeon
        :items="elementFilterC"
        :show-checkbox="true"
        :show-badge="false"
        checkbox-row-title="Todos"
        title-option="NombreAgrupacion"
        title-suboption="Articulo.Nombre"
        badge-text-color="var(--his-oliva)"
        :closed="true"
        :after-title="false"
        :mostrar-buscador="mostrarBarraBusqueda"
        :search-with-checkbox="true"
        :search-in-props="[
          'Articulo.Nombre',
          'Lote.Codigo',
          'UnidadContenedora.NumeroSerie',
        ]"
        :disabled-btn-options-no-items-selected="false"
        :virtual-list="true"
        @open-options="EventOpenOptions"
        @change-selected="EventSeleccionarRecuento"
        @check-all-option="EventCheckAllOption"
        @accordion-open="EventAccordionOpen"
      >
        <template #subOptionSubtitle="{ item }">
          <!-- <pre> {{ elementFilter[item] }}</pre> -->
          <div
            class="content-accordion-items"
            @click="EventSelectedElement(item)"
          >
            <div class="content-accordion-items__list">
              <div class="title">
                {{ (item.Articulo?.Nombre ?? '') }}
              </div>
              <div class="subtitle-code">
                {{ `${$t('common.code').toUpperCase()}: ${item.Articulo?.Codigo ?? ''}` }}
              </div>
              <div class="subtitle">
                {{ `${$t('common.lot').toUpperCase()}: ${item.Lote?.Codigo ?? ''}` }}
              </div>
              <div class="text">
                {{ `${$t('warehouse.labels.logisticsUnitShortIs').toUpperCase()} ${item.UnidadContenedora?.NumeroSerie ?? ''}` }}
              </div>
              <div class="text">
                {{ `${$t('warehouse.labels.serialNumberShortIs').toUpperCase()} ${item.NumeroSerie}` }}
              </div>
            </div>
            <div
              class="content-accordion-items__card"
            >
              <f7-card
                v-if="recuentoACiegasAPP == null || recuentoACiegasAPP === false || recuentoACiegasAPP === 'False'"
                outline
                :content="item.CantidadExistencias !== 0 ? item.CantidadExistencias : '--'"
                :footer="$t('common.stocks')"
              />
              <f7-card
                outline
                :content="item.CantidadRecontada !== 0 ? item.CantidadRecontada : '--'"
                :footer="$t('warehouse.info.count')"
                :style="{ background: (!item.Regularizado ? 'var(--his-tierra-white)' : '#ccebab') }"
              />
            </div>
          </div>
        </template>
      </UCAcordeon>
    </div>
    <!-- ACTIONS CANTIDAD RECUENTO -->
    <f7-actions
      v-model:opened="actionRecuentoActivo"
      class="inventory-regularization-and-count-actions-sheet"
    >
      <f7-block>
        <div class="content-action-sheet-inventory--items text-align-center">
          <span class="content-action-sheet-inventory--items__title">
            {{ $t('warehouse.labels.selectQuantityForSelectedArticleRecount') }}
          </span>

          <!-- `key` is needed to make the stepper catch the new min/max/decimal, etc correctly, after selecting new article -->
          <f7-stepper
            v-if="!esNumeroSerie"
            :key="elementoARecontar?.Id"
            fill
            class="content-action-sheet-inventory--items__stepper"
            :manual-input-mode="true"
            :min="0"
            :max="Number.MAX_SAFE_INTEGER"
            :value="cantidadesStepp.recuento.inicial"
            :decimal-point="selectedElementQuantityPrecision"
            :step="10 ** -selectedElementQuantityPrecision"
            :format-value="(/** @type {string} */ value) => FormatInputValue(value, selectedElementQuantityPrecision)"
            @stepper:change="cantidadesStepp.recuento.actual = FormatInputValue($event, selectedElementQuantityPrecision)"
          />

          <f7-stepper
            v-else
            fill
            class="content-action-sheet-inventory--items__stepper"
            :manual-input-mode="true"
            :min="0"
            :max="1"
            :value="cantidadesStepp.recuento.inicial"
            :step="1"
            :format-value="FormatInputValue"
            @stepper:change="cantidadesStepp.recuento.actual = FormatInputValue($event)"
          />
        </div>

        <div class="content-action-sheet-inventory--items__buttons">
          <a
            class="color-red"
            @click="actionRecuentoActivo = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-blue aceptar-button"
            @click="EventConfirmationCountSelected()"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-block>
    </f7-actions>

    <!-- ACTIONS NUEVO ARTICULO -->
    <f7-popup
      v-model:opened="actionNuevoArticulo"
      class="inventory-regularization-and-count-popup-new-article hide-popup-scanner"
    >
      <f7-page>
        <div class="content-filters padding">
          <div class="content-filters-search">
            <div class="content-filters__families">
              <UCSearchEntityERP
                ref="UCFamiliaArticulo"
                :title="$t('searchEntity.articleFamily.title.articleFamily')"
                :placeholder="$t('searchEntity.articleFamily.placeholder.selectAFamily')"
                :search-text="$t('searchEntity.articleFamily.searchText')"
                :search-cancellation-text="$t('searchEntity.articleFamily.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.articleFamily.searchNotFoundText')"
                :end-point-for-code-search="GetArticlesFamiliesByCode"
                :end-point-for-list="GetArticlesFamilies"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventFamiliaArticulosSelected"
              />
            </div>
            <div class="content-filters__articles">
              <UCSearchEntityERP
                ref="UCArticlesComponent"
                :title="$t('common.article')"
                :placeholder="$t('searchEntity.article.placeholder.searchByArticles')"
                :search-text="$t('searchEntity.article.searchText')"
                :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                :end-point-for-list="GetArticles"
                :end-point-for-code-search="GetArticlesByCode"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :qr-search-show="true"
                :qr-search-params="{
                  showInputButton: true,
                  fabButtonShow: false,
                  allowManualCodeEntry: true,
                  autoOpenCamera: false,
                  autofocusOnInput: true,
                }"
                @selection="EventArticlesSelected"
                @qr-open-search="EventQrOpen"
              />
            </div>
            <div class="content-filters__lotes">
              <UCSearchEntityERP
                :disabled="articulo == null ? true : (!articulo.PeticionLote ? true : false)"
                :title="$t('common.lot')"
                :placeholder="$t('searchEntity.lot.placeholder.searchByLots')"
                :search-text="$t('searchEntity.lot.searchText')"
                :search-cancellation-text="$t('searchEntity.lot.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.lot.searchNotFoundText')"
                :end-point-for-list="GetLotes"
                :end-point-for-code-search="GetLotesByCode"
                :property-entity-shown-input="['Codigo', 'Id']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Id']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventLotSelected"
              />
            </div><div class="content-filters__logistic-unit">
              <UCSearchEntityERP
                :title="$t('common.logisticsUnit')"
                :placeholder="$t('searchEntity.logisticUnit.placeholder.searchByLogisticUnit')"
                :search-text="$t('searchEntity.logisticUnit.searchText')"
                :search-cancellation-text="$t('searchEntity.logisticUnit.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.logisticUnit.searchNotFoundText')"
                :disabled="articulo == null ? true : (articulo.PeticionNumeroSerie ? true : false)"
                :end-point-for-list="GetLogisticUnit"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventLogisticUnitSelected"
              />
            </div>
            <div class="margin-left-half margin-top-half content-searcher-titulo">
              <span>
                {{ $t('searchEntity.serialNumber.title.serialNumber') }}
              </span>
            </div>

            <form class="content-input">
              <input
                :class=" { 'disabled-component': articulo == null ? true : (!articulo.PeticionNumeroSerie ? true : false) }"
                type="text"
                class="input-search"
                :placeholder="$t('searchEntity.serialNumber.placeholder.enterSerialNumber')"
                :disabled="articulo == null ? true : (!articulo.PeticionNumeroSerie ? true : false)"
                @input="numeroSerie = $event.target.value"
              >
            </form>
          </div>
          <div class="content-action-sheet-inventory--items text-align-center">
            <span class="content-action-sheet-inventory--items__title">
              {{ $t('warehouse.labels.selectQuantityForSelectedArticleRecount') }}
            </span>

            <!-- `key` is needed to make the stepper catch the new min/max/decimal, etc correctly, after selecting new article -->
            <f7-stepper
              :key="articulo?.Id"
              fill
              class="content-action-sheet-inventory--items__stepper"
              :manual-input-mode="true"
              :min="10 ** -selectedNewArticleQuantityPrecision"
              :max="Number.MAX_SAFE_INTEGER"
              :value="1"
              :disabled="!articulo"
              :decimal-point="selectedNewArticleQuantityPrecision"
              :step="10 ** -selectedNewArticleQuantityPrecision"
              :format-value="(/** @type {string} */ value) => FormatInputValue(value, selectedNewArticleQuantityPrecision)"
              @stepper:change="cantidadesStepp.nuevoArticulo.actual = FormatInputValue($event, selectedNewArticleQuantityPrecision)"
            />
          </div>
        </div>
        <div class="content-action-sheet-inventory--items__buttons">
          <a
            class="color-red padding"
            @click="actionNuevoArticulo = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-blue aceptar-button padding"
            @click="EventConfirmationNewArticleSelected()"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-page>
    </f7-popup>
    <!-- ACTIONS OPCIONES MULTIPLES -->
    <f7-actions
      class="inventory-regularization-and-count-actions"
      style="background: #fff;"
      :grid="true"
      :opened="actionChangesOpened"
      @actions:closed="actionChangesOpened = false"
    >
      <f7-block>
        <f7-actions-label>
          {{ $t('common.whatDoYouWantToDo') }}
        </f7-actions-label>
        <div class="content-action__buttons">
          <f7-actions-button
            v-if="listaRecuentos.length > 0 && listaRecuentos[0].eRec"
            class="content-action__buttons--red"
          >
            <template #media>
              <img
                src="@/static/icons/ic_delete.svg"
                width="50"
                class="img-gallery"
                @click="EliminarRecuento"
              >
            </template>
            <span>{{ $t('common.delete') }} {{
              listaRecuentos.length === 0
                ? (regularizado ? $t('warehouse.labels.regularization') : $t('warehouse.labels.count'))
                : (listaRecuentos[0].Regularizado ? $t('warehouse.labels.regularization') : $t('warehouse.labels.count'))
            }}</span>
          </f7-actions-button>
          <f7-actions-button
            v-if="listaRecuentos.length === 1"
            class="content-action__buttons--blue"
          >
            <template #media>
              <img
                src="@/static/img/ic_gallery.svg"
                width="50"
                class="img-gallery"
                @click="OpenImagenesEntidad"
              >
            </template>
            <span>{{ $t('common.images') }}</span>
          </f7-actions-button>
          <f7-actions-button
            v-if="regularizado"
            class="content-action__buttons--green"
          >
            <template #media>
              <img
                src="@/static/img/ic_check_green.svg"
                width="50"
                class="img-gallery"
                @click="Regularizar"
              >
            </template>
            <span>{{ $t('common.regularize') }}</span>
          </f7-actions-button>
        </div>
      </f7-block>
    </f7-actions>
    <!-- POP UP IMAGENES -->
    <UCCodeScanner
      ref="componentUCcodeScanner"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="true"
      :auto-open-camera="false"
      @code-reading="EventCodeScannerRead"
    />

    <f7-popup
      class="inventory-regularization-and-count-popup-images"
      :opened="popupImagenes"
      @popup:closed="popupImagenes = false"
    >
      <f7-navbar
        :title="$t('common.files')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupImagenes = false">
            <img
              :src="icClose"
              style="padding-right: 10px;"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCImagenesEntidad
        :is-active="popupImagenes"
        :entity-id="idEntidad"
        entity-type="Articulo"
        @open-pdf="popupImagenes = false"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import TheNavbar from '@/components/TheNavbar.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import icClose from '@/static/icons/ic_close.svg';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { FormaRecuento } from '@erpagroapp/common';

import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';

import { ConfirmDialogGH, HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import PCImagenesEntidad from '@/components/production/traceability/PCImagenesEntidad.vue';

/** @import { AcumuladoExistencias } from '@erpagroapp/types' */

export default {
  name: 'FrmInventoryRegularizationAndCount',
  components: {
    TheNavbar,
    UCAcordeon,
    UCSearchEntityERP,
    UCCodeScanner,
    PCImagenesEntidad,
  },

  props: {
    mainData: { type: Array, default: () => [] },
    filtro: { type: Object, default: undefined },
    acumulado: { type: Array, default: () => [] },
  },
  data() {
    return {
      icClose, // imagen close
      elementFilter: [
        {
          NombreAgrupacion: this.$t('warehouse.labels.statusNoRecount'),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'eSin',
        },
        {
          NombreAgrupacion: this.$t('warehouse.labels.statusCounted'),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'eRec',
        },
        {
          NombreAgrupacion: this.$t('warehouse.labels.statusRegularized'),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'eReg',
        },
      ],
      actionRecuentoActivo: false,
      actionNuevoArticulo: false,
      actionChangesOpened: false,
      popupImagenes: false,
      regularizado: false, // para controlar cuando aparece el icono de regularizar
      /** @type {AcumuladoExistencias | null} */
      elementoARecontar: null, // recoge el elemento que se pulsa para el recuento
      cantidadesStepp: {
        recuento: {
          inicial: null,
          actual: '',
        },
        nuevoArticulo: {
          actual: '',
        },
      },
      familiaArticulo: null,
      familiaArticuloSelect: null,
      articulo: null,
      almacen: null,
      fecha: null,
      unidadLogistica: null,
      listaRecuentos: [], // array con todos los recuentos que se han seleccionado con el check
      filter: {}, // filtro para actualizar los datos
      data: {}, // datos de recuentos
      /** @type {AcumuladoExistencias[]} */
      cumulative: [],
      numeroSerie: null,
      mostrarBarraBusqueda: false,
      idEntidad: null, // El id de la entidad para las imagenes
      qrOpen: false,
      recuentoACiegasAPP: useParamRef('RecuentoACiegasAPP'),
      countForm: useSettingRef('InventarioRegularizacion.FormaRecuento'),
    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },

    elementFilterC() {
      return this.elementFilter;
    },

    esNumeroSerie() {
      return this.mainData.length > 0 && this.mainData[0].NumeroSerie !== '';
    },

    selectedElementQuantityPrecision() {
      return this.elementoARecontar?.Articulo?.PrecisionCantidades ?? 0;
    },

    selectedNewArticleQuantityPrecision() {
      return this.articulo?.PrecisionCantidades ?? 0;
    },
  },
  created() {
    this.data = this.mainData;
    this.cumulative = this.acumulado;
    this.fecha = HiDateTimeSupport.FormatDateTime(
      new Date(this.filtro.date),
      'YYYY/MM/DD',
    );
    this.StartComponent();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.filter = this.filtro;
      this.almacen = this.filter.warehouse;
      this.familiaArticuloSelect = this.filter.articleFamily;
      this.FiltrarElementos(this.data, this.cumulative);
    },

    ChangedDate(date) {
      Log(this, this.ChangedDate.name);
      this.fecha = new Date(date).toJSON();

      this.filter.date = this.fecha;

      this.GetMainData(this.filter);
    },

    ChangeNumeroSerie(val) {
      Log(this, this.ChangeNumeroSerie.name);
      this.numeroSerie = val;
    },

    FiltrarElementos(mainData, acumulado) {
      Log(this, this.FiltrarElementos.name);
      this.ReloadElementFilter();

      mainData.forEach((elemento) => {
        elemento.eRec = true;
        elemento.esNS = this.esNumeroSerie && elemento.NumeroSerie !== null && elemento.NumeroSerie !== '';
        this.elementFilter[elemento.Regularizado ? 2 : 1].items.push(elemento);
      });

      acumulado.forEach((acumuladoItem) => {
        acumuladoItem.eRec = false;
        acumuladoItem.esNS = acumuladoItem.NumeroSerie !== null && acumuladoItem.NumeroSerie !== '';
        acumuladoItem.CantidadRecontada = 0;
        acumuladoItem.CantidadExistencias = acumuladoItem.Cantidad;
        acumuladoItem.FechaRecuento = new Date(this.fecha).toLocaleString();
        this.elementFilter[0].items.push(acumuladoItem);
      });
    },

    OpenImagenesEntidad() {
      Log(this, this.OpenImagenesEntidad.name);
      const entidad = this.listaRecuentos[0];
      this.idEntidad = entidad.Articulo.Id;
      this.popupImagenes = true;
    },

    FormatDateTime(dateTime) {
      return HiDateTimeSupport.FormatDateTime(dateTime, 'DD/MM/YYYY');
    },

    ReloadElementFilter() {
      this.elementFilter = [
        {
          NombreAgrupacion: this.$t('warehouse.labels.statusNoRecount'),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'eSin',
        },
        {
          NombreAgrupacion: this.$t('warehouse.labels.statusCounted'),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'eRec',
        },
        {
          NombreAgrupacion: this.$t('warehouse.labels.statusRegularized'),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'eReg',
        },
      ];
    },

    async Regularizar() {
      Log(this, this.Regularizar.name);

      const recuento = [];
      this.listaRecuentos.forEach((i) => {
        i.FechaRecuento = `${this.fecha} ${new Date('1/1/2001 00:00:00').toLocaleTimeString()}`;
        const { ...res } = i;
        recuento.push(res);
      });
      this.listaRecuentos = [];

      await this.UpdateRegularizeCount(recuento);
      this.actionChangesOpened = false;

      this.GetMainData(this.filter);
    },

    async EliminarRecuento() {
      Log(this, this.EliminarRecuento.name);

      const recuento = [];
      this.listaRecuentos.forEach((i) => {
        i.FechaRecuento = `${this.fecha} ${new Date('1/1/2001 00:00:00').toLocaleTimeString()}`;
        const { ...res } = i;
        recuento.push(res);
      });
      this.listaRecuentos = [];

      await this.DeleteCount(recuento);
      this.actionChangesOpened = false;

      this.GetMainData(this.filter);
    },

    //* ********************************** EVENTOS ***************************************\\

    async EventConfirmationCountSelected() {
      Log(this, this.EventConfirmationCountSelected.name);
      const recuento = this.elementFilter
        .flatMap((i) => i.items)
        .find((e) => e.Id === this.elementoARecontar.Id);

      if (!recuento) {
        return;
      }

      this.GetCumulativeUpdated()
        .then(async (cumulativeUpdated) => {
          if ((cumulativeUpdated.length === 1 && cumulativeUpdated[0].Cantidad === this.elementoARecontar.Cantidad) || cumulativeUpdated.length === 0) {
            recuento.CantidadRecontada = Number.parseFloat(this.cantidadesStepp.recuento.actual);
            recuento.FechaRecuento = `${this.fecha} ${new Date('1/1/2001 00:00:00').toLocaleTimeString()}`;

            if (recuento.UnidadContenedora !== null) {
              recuento.UnidadContenedora.Ubicacion = { Id: this.filter.location.Id };
            } else {
              recuento.UnidadContenedora = { Ubicacion: { Id: this.filter.location.Id } };
            }

            if (this.elementFilter.some((i) => i.Id === 'eSin' && i.items.includes(recuento))) {
              recuento.Id = 0;
            }

            const { checked, ...recuentoToSend } = recuento;

            this.elementoARecontar = null;

            if (this.countForm === FormaRecuento.Recuento) {
              await this.UpdateStockCount([recuentoToSend]);
            } else {
              await this.UpdateStockCountAndRegularization([recuentoToSend]);
            }

            this.actionRecuentoActivo = false;
            this.GetMainData(this.filter);
          } else {
            HiNotification.Toast(this.$t('warehouse.info.stockInfoUpdated'), 2000);
          }
        })
        .catch((error) => {
          LogError(this, this.EventConfirmationCountSelected.name, error);
        });
    },

    async GetCumulativeUpdated() {
      Log(this, this.GetCumulativeUpdated.name);
      const filtro = {
        date: this.filtro.date,
        article: this.elementoARecontar.Articulo,
        warehouse: this.elementoARecontar.Almacen,
        location: this.elementoARecontar.Ubicacion ? this.elementoARecontar.Ubicacion : this.filter.location,
        articleFamily: null,
        logisticUnit: this.filtro.logisticUnit ?? this.elementoARecontar.UnidadContenedora,
        serialNumber: this.elementoARecontar.NumeroSerie,
      };

      await this.GetCumulativeStock(filtro);

      const resCumulative = this.cumulative.filter((f) => {
        const isSameLote = (f.Lote !== null ? f.Lote.Id : null) === (this.elementoARecontar.Lote !== null ? this.elementoARecontar.Lote.Id : null);
        const hasSameNumeroSerie = f.NumeroSerie !== '' && f.NumeroSerie === this.elementoARecontar.NumeroSerie;
        const hasSameUnidadContenedora = f.UnidadContenedora !== null && f.UnidadContenedora.Id === this.elementoARecontar.UnidadContenedora.Id;

        if (hasSameNumeroSerie) {
          return isSameLote && hasSameNumeroSerie;
        } if (hasSameUnidadContenedora) {
          return isSameLote && hasSameUnidadContenedora;
        }
        return isSameLote;
      });

      return resCumulative;
    },

    async EventConfirmationNewArticleSelected() {
      Log(this, this.EventConfirmationNewArticleSelected.name);

      if (!this.familiaArticulo) {
        HiNotification.Toast(this.$t('warehouse.info.needToSelectArticleFamily'));
        return;
      }

      if (!this.articulo) {
        HiNotification.Toast(this.$t('warehouse.info.needToSelectArticle'));
        return;
      }

      const rec = [];

      this.elementFilter[1].items.forEach((f) => {
        if (f.Articulo.Id === this.articulo.Id && (f.Lote != null ? f.Lote.Id : f.Lote) === (this.lote != null ? this.lote.Id : this.lote)
          && (f.UnidadContenedora != null ? f.UnidadContenedora.Id : f.UnidadContenedora) === (this.unidadLogistica != null ? this.unidadLogistica.Id : this.unidadLogistica)) {
          rec.push(f);
        }
      });

      if (rec.length > 0) {
        HiNotification.Toast(this.$t('warehouse.info.similarCountAlreadyExists'));
        return;
      }

      if (this.articulo.PeticionLote && !this.lote) {
        HiNotification.Toast(this.$t('warehouse.info.needToSelectLot'));
        return;
      }

      if (this.articulo.PeticionNumeroSerie && (!this.numeroSerie || (typeof this.numeroSerie === 'string' && this.numeroSerie.trim() === ''))) {
        HiNotification.Toast(this.$t('warehouse.info.needToSelectSerialNumber'));
        return;
      }

      const quantity = Number.parseFloat(this.cantidadesStepp.nuevoArticulo.actual);

      if (quantity === 0) {
        HiNotification.Toast(this.$t('warehouse.info.needToSelectQuantity'));
        return;
      }

      const recuento = [{
        FechaRecuento: this.fecha,
        Id: 0,
        Articulo: this.articulo,
        Almacen: this.almacen,
        Cantidad: quantity,
        CantidadExistencias: 0,
        CantidadRecontada: quantity,
        Lote: this.lote,
        UnidadContenedora: this.unidadLogistica != null ? this.unidadLogistica : { Ubicacion: this.filter.location, Id: 0 },
        Partida: null,
        NumeroSerie: this.numeroSerie,
      }];

      await this.UpdateStockCount(recuento);
      this.GetMainData(this.filter);

      this.actionNuevoArticulo = false;
    },

    EventPressNewArticle() {
      Log(this, this.EventPressNewArticle.name);
      this.actionNuevoArticulo = true;
    },

    async EventSelectedElement(e) {
      Log(this, this.EventSelectedElement.name);
      this.elementoARecontar = e;

      if (!this.recuentoACiegasAPP && e !== null) {
        this.cantidadesStepp.recuento.actual = e.CantidadRecontada !== 0 ? e.CantidadRecontada.toString() : e.CantidadExistencias.toString();
      } else {
        this.cantidadesStepp.recuento.actual = '';
      }

      this.cantidadesStepp.recuento.inicial = Number(this.cantidadesStepp.recuento.actual);
      this.actionRecuentoActivo = !e.Regularizado;
    },

    EventOpenOptions(value) {
      Log(this, this.EventOpenOptions.name);

      this.regularizado = false;
      if (value.length === 0) {
        HiNotification.Toast('No hay recuentos seleccionados');
      }
      if (value.length > 0 && value[0].Regularizado != null && !value[0].Regularizado) {
        this.regularizado = true;
      }

      this.actionChangesOpened = true;
    },

    EventSeleccionarRecuento(value) {
      value.FechaRecuento = new Date(this.fecha).toLocaleString();
      this.listaRecuentos.push(value);
      this.listaRecuentos = this.listaRecuentos.filter((item, index) => this.listaRecuentos.indexOf(item) === index && item.checked);
    },

    EventAccordionOpen() {
      Log(this, this.EventAccordionOpen.name);
      this.listaRecuentos = [];
    },

    EventFamiliaArticulosSelected(obj) {
      Log(this, this.EventFamiliaArticulosSelected.name);
      this.familiaArticulo = obj;
      if (obj === null) {
        this.$refs.UCArticlesComponent.Clear({
          autoFocus: false,
          noEmitEvent: true,
        });
      }
    },
    EventArticlesSelected(obj) {
      Log(this, this.EventArticlesSelected.name);
      this.articulo = obj;
      if (this.familiaArticulo === null && obj !== null) {
        callExecuteSPERP(
          'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
          [
            { NombreParametro: 'filtro', Valor: '' },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsArticulo', Valor: this.articulo.Id },
          ],
          'Comun.FamiliaArticuloJSON',
        ).then((result) => {
          if (result.status !== 200) {
            return;
          }
          this.$refs.UCFamiliaArticulo.SelectEntity(result.data[0], true);
        });
      }
    },

    EventLogisticUnitSelected(obj) {
      Log(this, this.EventLogisticUnitSelected.name);
      this.unidadLogistica = obj;
    },

    EventLotSelected(obj) {
      Log(this, this.EventLotSelected.name);
      this.lote = obj;
    },

    EventOpenCodeSearch() {
      Log(this, this.EventOpenCodeSearch.name);
      this.$refs.componentUCcodeScanner.Open();
    },

    async EventCodeScannerRead(codigo) {
      Log(this, this.EventCodeScannerRead.name);
      this.qrOpen = true;
      this.GetArticlesByCode(codigo).then((result) => {
        if (result.data.length > 0) {
          this.mostrarBarraBusqueda = true;
          const item = result.data[0];

          this.valueSearch = item.Nombre;
        } else {
          this.qrOpen = true;
          this.GetLogisticUnitByCode(codigo).then((resultado) => {
            if (resultado.data.length > 0) {
              this.mostrarBarraBusqueda = true;
              const item = resultado.data[0];

              this.valueSearch = item.InfoProducto.Nombre;
            }
          });
        }
      });
      this.qrOpen = false;
    },

    EventQrOpen(val) {
      Log(this, this.EventQrOpen.name);
      this.qrOpen = val;
    },
    EventCheckAllOption(val) {
      Log(this, this.EventCheckAllOption.name);

      val.forEach((v) => {
        this.EventSeleccionarRecuento(v);
      });
    },

    // ActualizarDatos(articulo) {
    //   Log(this, this.ActualizarDatos.name);

    //   const filter = {
    //     location: this.filter.location,
    //     articleFamily: this.filter.articleFamily,
    //     article: articulo,
    //     warehouse: this.filter.warehouse,
    //     date: this.fecha,
    //   };

    //   this.GetMainData(filter);
    // },

    /**
     * Updates the amount input.
     * @param {string} value - The current value.
     * @param {number | undefined} [precision] - The precision.
     * @returns {string} The new value.
     */
    FormatInputValue(value, precision) {
      if (value === '') {
        return '';
      }

      const numericValue = Number(value);
      return Number.isInteger(numericValue) ? numericValue.toString() : numericValue.toFixed(precision ?? 0);
    },

    //* ********************************** CONECTIONS ***************************************\\

    async UpdateStockCount(recuento) {
      Log(this, this.UpdateStockCount.name);
      HiDialog.Preloader(true, this.$t('warehouse.info.makingCount'), false);

      try {
        let result = null;
        result = await APIErp.callStockCount(recuento);
        if (result.statusText === 'OK' || result.status === 200) {
          HiDialog.Preloader(false);
          return null;
        }
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.countingError'));
        return null;
      } catch (error) {
        LogError(this, this.UpdateStockCount.name, error);
        HiDialog.Preloader(false);
        return null;
      }
    },

    async UpdateStockCountAndRegularization(recuento) {
      Log(this, this.UpdateStockCountAndRegularization.name);
      HiDialog.Preloader(true, 'Realizando recuento y regularización', false);

      try {
        let result = null;
        result = await APIErp.callStockCountAndRegularization(recuento);
        if (result.statusText === 'OK' || result.status === 200) {
          HiDialog.Preloader(false);
          return null;
        }
        HiDialog.Preloader(false);
        HiNotification.Toast('No es posible realizar el recuento y regularización');
        return null;
      } catch (error) {
        LogError(this, this.UpdateStockCountAndRegularization.name, error);
        HiDialog.Preloader(false);
        return null;
      }
    },

    async DeleteCount(recuento) {
      Log(this, this.DeleteCount.name);

      if (recuento[0].Regularizado) {
        HiDialog.Preloader(true, this.$t('warehouse.info.deletingRegularization'), false);
      } else {
        HiDialog.Preloader(true, this.$t('warehouse.info.deletingCount'), false);
      }

      try {
        let result = null;
        result = await APIErp.callDeleteCount(recuento);
        if (result.statusText === 'OK' || result.status === 200) {
          HiDialog.Preloader(false);
          const datos = result.data;

          datos.respuestasValidacion.forEach((e) => {
            if (e.valor === false) {
              HiNotification.Toast(e.mensaje);
            } else {
              HiNotification.Toast(this.$t('warehouse.info.deletedSuccessfully'));
            }
          });
          return null;
        }
        HiDialog.Preloader(false);
        if (recuento[0].Regularizado) {
          HiNotification.Toast(this.$t('warehouse.info.deletingCountError'));
        } else {
          HiNotification.Toast(this.$t('warehouse.info.deletingRegularizationError'));
        }
        return null;
      } catch (error) {
        LogError(this, this.DeleteCount.name, error);
        HiDialog.Preloader(false);
        return null;
      }
    },

    async UpdateRegularizeCount(recuento) {
      Log(this, this.UpdateRegularizeCount.name);

      HiDialog.Preloader(true, this.$t('warehouse.info.regularizing'), false);

      try {
        let result = null;
        result = await APIErp.callRegularizeCount(recuento);
        if (result.statusText === 'OK' || result.status === 200) {
          HiDialog.Preloader(false);
          return null;
        }
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.regularizingError'));
        return null;
      } catch (error) {
        LogError(this, this.UpdateRegularizeCount.name, error);
        HiDialog.Preloader(false);
        return null;
      }
    },

    /* familia articulos */
    GetArticlesFamiliesByCode(params) {
      Log(this, this.GetArticlesFamiliesByCode.name);
      return callExecuteSPERP(
        'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsArticulo', Valor: '' },
        ],
        'Comun.FamiliaArticuloJSON',
      );
    },
    GetArticlesFamilies() {
      Log(this, this.GetArticlesFamilies.name);
      return callExecuteSPERP(
        'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsArticulo', Valor: '' },
        ],
        'Comun.FamiliaArticuloJSON',
      );
    },
    /* articulos */
    GetArticles() {
      Log(this, this.GetArticles.name);
      if (this.familiaArticulo !== null) {
        return callExecuteSPERP(
          'APPERPAGRO_ArticuloXIdGrupoEmpresarialXFamiliarArticulo',
          [
            { NombreParametro: 'filtro', Valor: '' },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsFamiliarArticulo', Valor: this.familiaArticulo.Id },
          ],
          'Comun.ArticuloJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsUbicacion', Valor: this.filter.location !== null ? this.filter.location.Id : '' },
        ],
        'Comun.ArticuloJSON',
      );
    },
    GetArticlesByCode(params) {
      Log(this, this.GetArticlesByCode.name);
      if (this.qrOpen) {
        this.qrOpen = false;
        if (this.familiaArticulo !== null) {
          return callExecuteSPERP(
            'APPERPAGRO_ArticuloXIdGrupoEmpresarialXFamiliarArticulo',
            [
              { NombreParametro: 'filtro', Valor: `barcode:${params}` },
              { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
              { NombreParametro: 'idsFamiliarArticulo', Valor: this.familiaArticulo.Id },
            ],
            'Comun.ArticuloJSON',
          );
        }
        return callExecuteSPERP(
          'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsUbicacion', Valor: this.filter.location !== null ? this.filter.location.Id : '' },
          ],
          'Comun.ArticuloJSON',
        );
      }

      if (this.familiaArticulo !== null) {
        return callExecuteSPERP(
          'APPERPAGRO_ArticuloXIdGrupoEmpresarialXFamiliarArticulo',
          [
            { NombreParametro: 'filtro', Valor: `q:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsFamiliarArticulo', Valor: this.familiaArticulo.Id },
          ],
          'Comun.ArticuloJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_ArticuloXIdGrupoEmpresarialXUbicacion',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsUbicacion', Valor: this.filter.location !== null ? this.filter.location.Id : '' },
        ],
        'Comun.ArticuloJSON',
      );
    },
    /* unidad logistica */
    GetLogisticUnitByCode(code) {
      Log(this, this.GetLogisticUnitByCode.name);
      if (this.qrOpen) {
        this.qrOpen = false;
        return callExecuteSPERP(
          'APPERPAGRO_ArticulosNumeroSerieRecuentoExistencias',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${code}` }, // Id, barcode, numeroserie
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          ],
          'Almacen.UnidadContenedoraJSON',
        );
      }
      return null;
    },
    /* unidad logistica */
    GetLogisticUnit() {
      Log(this, this.GetLogisticUnit.name);
      return callExecuteSPERP(
        'APPTRAZABILIDAD_ObtenerArticulosNumerosSerie',
        [
          { NombreParametro: 'IdFamilia', Valor: this.familiaArticuloSelect != null ? this.familiaArticuloSelect.Id : 0 },
          { NombreParametro: 'IdLote', Valor: this.lote != null ? this.lote.Id : 0 },
        ],
        'Almacen.UnidadContenedoraJSON',
      );
    },

    /* lotes */
    async GetLotes() {
      Log(this, this.GetLotes.name);
      return callExecuteSPERP(
        'APPTRAZABILIDAD_ObtenerLotes',
        [
          { NombreParametro: 'EsMateriaPrima', Valor: 0 },
          { NombreParametro: 'IdFamilia', Valor: this.familiaArticulo.Id },
          { NombreParametro: 'IdGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        ],
        'Almacen.LoteJSON',
      );
    },
    async GetLotesByCode(params) {
      Log(this, this.GetLotesByCode.name);
      try {
        const result = await callExecuteSPERP(
          'APPTRAZABILIDAD_ObtenerLotesPorCodigo',
          [
            { NombreParametro: 'filtro', Valor: `q:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          ],
          'Almacen.LoteJSON',
        );
        if (result.statusText === 'OK' || result.status === 200) {
          if (result.data.length > 0) {
            return result;
          }
          if (result.data.length === 0) {
            const confirmRes = await ConfirmDialogGH(
              this.$t('warehouse.info.lotDoesNotExistCreateNewOne', { value: params }),
              this.$t('warehouse.info.lotDoesNotExist'),
            );

            if (confirmRes) {
              const lote = {
                Id: 0,
                Codigo: params,
              };
              APIErp.callNewLot(lote).then((res) => {
                if (res.statusText === 'OK' || res.status === 200) {
                  this.lote = res.data.tag;
                }
              });
            } else {
              HiNotification.Toast(this.$t('warehouse.info.newLotCreationCancelled'));
            }

            return result;
          }
        }
        return null;
      } catch (error) {
        LogError(this, this.GetLotesByCode.name, error);
        return null;
      }
    },

    async GetMainData(filtro) {
      Log(this, this.GetMainData.name);
      await this.GetCumulativeStock(filtro);
      await this.GetStockCount(filtro);
      this.mostrarBarraBusqueda = false;
      this.FiltrarElementos(this.data, this.cumulative);
    },

    async GetStockCount(filtro) {
      Log(this, this.GetStockCount.name);
      HiDialog.Preloader(true, this.$t('warehouse.info.loadingCountAndInventory'), false);
      const fecha = `${this.fecha} ${new Date('1/1/2001 00:00:00').toLocaleTimeString()}`;
      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPERPAGRO_RecuentoExistencias',
          [
            { NombreParametro: 'FechaRecuento', Valor: fecha },
            { NombreParametro: 'IdArticulo', Valor: filtro.article !== null ? filtro.article.Id : filtro.article },
            { NombreParametro: 'IdAlmacen', Valor: filtro.warehouse !== null ? filtro.warehouse.Id : filtro.warehouse },
            { NombreParametro: 'Ubicacion', Valor: filtro.location !== null ? filtro.location.Id : filtro.location },
            { NombreParametro: 'FamiliaArticulo', Valor: filtro.articleFamily !== null ? filtro.articleFamily.Id : filtro.articleFamily },
            { NombreParametro: 'IdUnidadLogistica', Valor: filtro.logisticUnit !== null ? filtro.logisticUnit.Id : null },
          ],
          'Almacen.RecuentoExistenciaJSON',
        );

        if (result.statusText === 'OK' || result.status === 200) {
          this.data = result.data;
          HiDialog.Preloader(false);
          return null;
        }
        HiDialog.Preloader(false);
        return null;
      } catch (error) {
        LogError(this, this.GetStockCount.name, error);
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.noCountFoundWithTheseFilters'));
        this.showPreload = false;
        return null;
      }
    },

    async GetCumulativeStock(filtro) {
      Log(this, this.GetCumulativeStock.name);
      const date = HiDateTimeSupport.FormatDateTime(
        new Date(filtro.date),
        'DD/MM/YYYY',
      );
      this.cumulative = [];
      HiDialog.Preloader(true, this.$t('warehouse.info.loadingCountAndInventory'), false);
      const fecha = date;
      const articulo = filtro.article ? filtro.article.Id : 0;
      const almacen = filtro.warehouse ? filtro.warehouse.Id : null;
      const ubicacion = filtro.location ? filtro.location.Id : null;
      const familia = filtro.articleFamily ? filtro.articleFamily.Id : 0;
      const unidadLogistica = filtro.logisticUnit ? filtro.logisticUnit.Id : null;

      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPERPAGRO_ExistenciasAFechaParaRecuento',
          [
            { NombreParametro: 'fecha', Valor: fecha },
            { NombreParametro: 'IdArticulo', Valor: articulo },
            { NombreParametro: 'IdAlmacen', Valor: almacen },
            { NombreParametro: 'Ubicacion', Valor: ubicacion },
            { NombreParametro: 'FamiliaArticulo', Valor: familia },
            { NombreParametro: 'IdUnidadLogistica', Valor: unidadLogistica },
            { NombreParametro: 'IdCentro', Valor: this.userEnviroment.EntornoDeTrabajo.Centro.Id },
          ],
          'Almacen.AcumuladoExistenciasJSON',
        );

        if (result.status === 200) {
          this.cumulative = result.data.reduce((acc, e) => {
            if (!filtro.serialNumber || e.NumeroSerie === filtro.serialNumber) {
              acc.push({ ...e, Regularizado: null });
            }
            return acc;
          }, []);
        }

        HiDialog.Preloader(false);
        return null;
      } catch (error) {
        LogError(this, this.GetCumulativeStock.name, error);
        this.cumulative = [];
        HiDialog.Preloader(false);
        HiNotification.Toast(this.$t('warehouse.info.noCountFoundWithTheseFilters'));
        this.showPreload = false;
        return null;
      }
    },

  },
};
</script>

<style lang="scss">
.main-inventory-regularization-and-count {
  --inventory-search-bar-height: 50px;

  .navbar {
    .navbar-inner {
      .left {
        max-width: calc(100% - 99px);
      }
    }
  }

  .page-content {
    overflow-y: hidden;
  }

  .search-bar {
    display: flex;
    background: var(--his-oliva);
    justify-content: space-between;
    align-items: center;
    height: var(--inventory-search-bar-height);
    padding-left: 25px;
    padding-right: 15px;
    color: #fff;
  }

  .title {
    overflow-x: hidden;
  }

  .content-accordion {
    .storybook-action-sorted-accordion {
      .content-checkbox-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: var(--his-disabled);
        color: var(--his-oliva);
        font-size: 14px;

        &__check label {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          i {
            margin-right: 12px;
          }
        }

        &__actions {
          height: 32px;
          width: 32px;
        }
      }
    }

    .content-accordion-items {
      display: grid;
      grid-template-columns: [first] 38vw [line2] 50vw [end];
      grid-column-gap: 1px;

      &__list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 5px;

        .title,
        .text,
        .subtitle {
          overflow: hidden;
          padding-bottom: 2px;
          font-size: 13px;
          -webkit-line-clamp: 3;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .subtitle-code {
          color: var(--his-oliva);
          font-weight: 400;
          font-size: 12px;
        }

        .subtitle {
          color: var(--his-soft-blue);
          font-weight: 400;
          font-size: 12px;
        }

        .text {
          color: var(--his-orange);
          font-weight: 400;
          font-size: 11px;
        }
      }

      &__card {
        --f7-card-margin-horizontal: 2px;
        --f7-card-margin-vertical: 5px;
        --f7-card-footer-font-size: 12px;
        --f7-card-content-padding-horizontal: 10px;
        --f7-card-content-padding-vertical: 10px;
        --f7-card-footer-padding-horizontal: 5px;
        --f7-card-footer-min-height: 40px;
        --f7-card-bg-color: #eff3ff;

        display: flex;
        margin: 5px;
        padding-left: 10px;

        .card {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          font-size: 20px;
          width: calc(100vw - 50%);
        }
      }

      .item-content {
        display: flex;
        align-items: flex-start;

        .icon-checkbox {
          margin-top: 10px;
        }
      }
    }

    .accordion-item-opened {
      > .accordion-item-content ul {
        overflow-y: scroll;
        height: calc(100vh
          - var(--f7-page-navbar-offset)
          - var(--inventory-search-bar-height)
          - (var(--f7-list-item-min-height) * 3) /* the 3 accordions */
          - 45px /* the check all and options button bar */
          - var(--information-bar-height)
        );
      }

      > .item-inner {
        > ::after {
          content: "";
          position: absolute;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: none;
          left: 10px;
          bottom: -8px;
          z-index: 2;
        }
      }
    }
  }
}

.inventory-regularization-and-count-actions {
  .content-action__buttons {
    margin-left: 0;
    margin-right: 0;

    .actions-button {
      width: 35vw;
    }

    &--blue {
      .actions-button-media {
        justify-content: center;
      }
    }
  }
}

.inventory-regularization-and-count-popup-new-article {
  background-color: #fff;

  .content-filters {
    --search-input-height: 36px;
    --search-input-color: #848192;
    --search-font-size: 14px;
    --search-font-weight: 400;
    --search-btn-min-width: 40px;

    display: flex;
    flex-direction: column;
    height: calc(100% - 90px);
    background-color: #fff;

    &-search {
      --f7-block-padding-horizontal: 0px;
      --f7-block-title-margin-bottom: 2px;
      --f7-block-title-text-color: var(--his-slate-blue);

      display: flex;
      flex-direction: column;
      padding-bottom: 50px;
    }

    &__articles {
      display: block;
    }

    span {
      color: var(--his-slate-blue);
      font-size: 13px;
      padding-left: 13px;
    }

    .content-searcher-erp {
      margin-bottom: 13px;

      .div-qr-search {
        border: none;
        margin-left: 5px;
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;

        img {
          content: url("@/static/icons/ic_qr.svg");
        }
      }
    }

    .content-input {
      height: 36px;

      input {
        height: 36px;
        color: #848192;
        font-size: 14px;
        font-weight: 400;
      }

      .input-search-icon {
        width: 24px;
      }
    }
  }

  .disabled-component {
    opacity: 0.6;
    pointer-events: none;
  }
}

.inventory-regularization-and-count-popup-images {
  overflow-y: scroll;
}

.inventory-regularization-and-count-popup-new-article,
.inventory-regularization-and-count-actions-sheet {
  background-color: #fff;

  .content-action-sheet-inventory {
    &--items {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 60px;

      &__title {
        font-size: 14px;
        font-weight: 400;
        padding-bottom: 24px;
        color: var(--his-steel-blue);
      }

      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;

        a {
          font-size: 14px;
          font-weight: 400;
        }

        .aceptar-button {
          font-size: 18px;
          font-weight: 500;
        }
      }

      &__stepper {
        --f7-stepper-fill-button-text-color: #fff;
        --f7-stepper-height: 36px;
        --f7-stepper-border-radius: 0px;

        .stepper-input-wrap {
          input {
            width: 100px;
            border: none;
          }
        }

        .actions-label::after {
          height: 0 !important;
        }
      }
    }
  }
}
</style>
